
import { 
  Description, Folder, Image, PictureAsPdf, 
  Archive, Code, Audiotrack, Videocam, 
  DeveloperMode, InsertDriveFile, TableChart,
  Article, Settings,
} from "@mui/icons-material";
import React from "react";
import { themeColors } from "./theme";

export const getFileIcon = (fileName: string, isDirectory: boolean): React.ReactElement => {
  if (isDirectory) {
    return <Folder sx={{ color: themeColors.primary }} />;
  }

  const extension = fileName.split('.').pop()?.toLowerCase();

  switch (extension) {
    // Image files
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
    case 'bmp':
    case 'webp':
    case 'svg':
    case 'ico':
      return <Image sx={{ color: themeColors.primary }} />;
    
    // Document files
    case 'pdf':
      return <PictureAsPdf sx={{ color: '#f44336' }} />;
    case 'doc':
    case 'docx':
    case 'rtf':
      return <Article sx={{ color: '#2196f3' }} />;
    
    // Data files
    case 'csv':
    case 'xlsx':
    case 'xls':
      return <TableChart sx={{ color: '#4caf50' }} />;
    
    // Archive files
    case 'zip':
    case 'tar':
    case 'gz':
    case 'rar':
    case '7z':
    case 'bz2':
      return <Archive sx={{ color: '#ff9800' }} />;
    
    // Code files
    case 'js':
    case 'jsx':
    case 'ts':
    case 'tsx':
    case 'html':
    case 'css':
    case 'scss':
    case 'less':
    case 'json':
    case 'xml':
    case 'yaml':
    case 'yml':
    case 'py':
    case 'java':
    case 'cpp':
    case 'c':
    case 'php':
    case 'rb':
    case 'go':
    case 'rs':
    case 'swift':
    case 'kt':
      return <Code sx={{ color: themeColors.primary }} />;
    
    // Config/data files
    case 'env':
    case 'config':
    case 'conf':
    case 'ini':
    case 'toml':
      return <Settings sx={{ color: themeColors.textSecondary }} />;
    case 'log':
      return <Description sx={{ color: themeColors.textSecondary }} />;
    
    // Audio files
    case 'mp3':
    case 'wav':
    case 'ogg':
    case 'flac':
    case 'aac':
    case 'm4a':
      return <Audiotrack sx={{ color: '#9c27b0' }} />;
    
    // Video files
    case 'mp4':
    case 'mov':
    case 'avi':
    case 'mkv':
    case 'wmv':
    case 'flv':
    case 'webm':
      return <Videocam sx={{ color: '#f44336' }} />;
    
    // Executable files
    case 'exe':
    case 'sh':
    case 'bat':
    case 'cmd':
    case 'app':
    case 'dmg':
      return <DeveloperMode sx={{ color: '#ff5722' }} />;
    
    // Text files
    case 'txt':
    case 'md':
    case 'markdown':
    case 'readme':
      return <Description sx={{ color: themeColors.textSecondary }} />;
    
    default:
      return <InsertDriveFile sx={{ color: themeColors.textSecondary }} />;
  }
};
